import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {GlobalsService} from '../../../../shared/services/globals.service';

@Component({
  selector: 'app-translation-add-csv',
  templateUrl: './translation-add-csv.component.html',
  styleUrls: ['./translation-add-csv.component.scss']
})
export class TranslationAddCsvComponent implements OnInit {
  entityForm: UntypedFormGroup;
  redirecturl = '/admin/translation';
  serverRoot: string;

  constructor(protected route: ActivatedRoute,
              protected router: Router,
              private fb: UntypedFormBuilder,
              protected http: HttpClient,
              private globalsservice: GlobalsService) {
    this.serverRoot = this.globalsservice.getBffapiroot();
  }

  ngOnInit(): void {
    this.entityForm = this.fb.group({
      csv: ['prefix,  keyword,  format,  description,  multiline, translation_en,  translation_de,  translation_fr;', Validators.required]
    });
  }

  cancelFormSubmit() {
    this.router.navigate([this.redirecturl]);
  }

  onEntityFormSubmit() {
    console.log(this.entityForm.value);


    if (this.entityForm.valid) {
      const query = this.createEntity(this.entityForm.value);
      query.subscribe((allresults) => {
        this.router.navigate([this.redirecturl]);
      });
    }
  }

  createEntity(entityjson: {}): Observable<any> {
    const formData = new FormData();
    formData.append('entity', JSON.stringify(entityjson));

    const url = '/v1/admin/many-translations';
    return this.http.post(this.serverRoot + url, formData);
  } // createEntity

}
